import React from "react";
import { useTranslation } from "react-i18next";

const REGISTER_FORM_URLS = [
    "https://forms.gle/whQjGWDgHnRCNZtE7",
    "https://forms.gle/pvTukeh2WpXL83Jv6",
    "https://forms.gle/bJZgPM6HaDyrnXQu8",
];

const ANNOUNCE_UNTIL = new Date(2026, 8, 20);

function AnnouncementBar() {
    const { t } = useTranslation();
    if (new Date() >= ANNOUNCE_UNTIL) {
        return null;
    }
    const ANNOUNCE_URL = REGISTER_FORM_URLS[0];
    return (
        <div className="landing-announce">
            <span>{t("announcementText")}</span>
            <a href={ANNOUNCE_URL} target="_blank" rel="noopener noreferrer">
                {t("announcementCta")} →
            </a>
        </div>
    );
}
export default AnnouncementBar;